module.exports = __webpack_public_path__ + "static/media/show_black.4f4c3aeb.svg";